var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUthermFull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 276.653,
    height: 272.285,
    viewBox: "0 0 276.653 272.285",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    transform: "translate(-424 -343.782)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(424 343.782)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M3.635-2.081c1.114,0,1.17-1.6,2.1,6.14S7.344,28.877,7.344,28.877V88.992c0,2.911-2.81,4.051-4.423,4.051S0,90.682,0,87.771V28.877S.367,11.8,1.276,4.059,2.521-2.081,3.635-2.081Z",
    transform: "translate(17.094 2.218)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect43",
    width: 276.653,
    height: 101.812,
    rx: 4.806,
    transform: "translate(0 37.373)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_235",
    "data-name": "Rectangle 235",
    width: 258.277,
    height: 84.335,
    rx: 4,
    transform: "translate(10.067 46.065)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect471",
    width: 19.557,
    height: 20.51,
    rx: 1.44,
    transform: "translate(48.558 52.836)",
    fill: "#9f9f9f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect471-2",
    width: 2.018,
    height: 12.016,
    rx: 0.843,
    transform: "translate(24.439 56.911)",
    fill: "#9f9f9f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect471-2-4",
    width: 2.018,
    height: 12.016,
    rx: 0.843,
    transform: "translate(28.316 56.911)",
    fill: "#9f9f9f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect471-2-4-5",
    width: 2.018,
    height: 12.016,
    rx: 0.843,
    transform: "translate(32.121 57.256)",
    fill: "#9f9f9f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect471-2-4-5-7",
    width: 2.018,
    height: 12.016,
    rx: 0.843,
    transform: "translate(35.758 57.256)",
    fill: "#9f9f9f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect471-0",
    width: 19.557,
    height: 20.51,
    rx: 1.44,
    transform: "translate(210.296 53.945)",
    fill: "#9f9f9f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect471-8",
    width: 97.935,
    height: 20.51,
    rx: 5.565,
    transform: "translate(89.426 53.945)",
    fill: "#9f9f9f"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_261",
    "data-name": "Rectangle 261",
    width: 12,
    height: 60,
    rx: 3,
    transform: "translate(557 491)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M3,0H9a3,3,0,0,1,3,3,60.324,60.324,0,0,1,1.995,22C12.767,36.844,7.087,50.391,7.087,50.391c0,1.657,1.384,4.6.362,7S3,60,3,60a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0Z",
    transform: "translate(548.224 556.967) rotate(43)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M3,60H9a3,3,0,0,0,3-3,60.324,60.324,0,0,0,1.995-22C12.767,23.156,7.087,9.609,7.087,9.609c0-1.657,1.384-4.6.362-7S3,0,3,0A3,3,0,0,0,0,3V57A3,3,0,0,0,3,60Z",
    transform: "translate(622.359 600.849) rotate(137)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_262",
    "data-name": "Rectangle 262",
    width: 53,
    height: 51,
    rx: 23,
    transform: "translate(537 521)",
    fill: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_260",
    "data-name": "Rectangle 260",
    width: 53,
    height: 12,
    rx: 3,
    transform: "translate(536 483)",
    fill: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_263",
    "data-name": "Rectangle 263",
    width: 24,
    height: 21,
    rx: 10,
    transform: "translate(529 521)",
    fill: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M3.539-2.544H9.507a51.607,51.607,0,0,1,5.03,17.606c1.128,10.47,0,29.781,0,29.781a3.654,3.654,0,0,1-2.888,3.333,15.406,15.406,0,0,1-8.687,0A4.333,4.333,0,0,1-.372,44.843s-.826-19.311,0-29.781A60.6,60.6,0,0,1,3.539-2.544Z",
    transform: "translate(555.851 567.266)",
    fill: "#e6e6e6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUthermFull);
export default __webpack_public_path__ + "static/media/utherm-full.2b6c2bf8c531e6c1fe7a0177e0e4e422.svg";
export { ForwardRef as ReactComponent };